<div class="container-fluid" [@slideInOut]="animationState">
  <div class="overlay mx-0 col-md-12">
    <div class="h-100-not-mobile row align-items-center">
      <div
        class="adminClickContainer"
        data-location="adminPanel"
        (click)="navigate('/admin')"
      >
        <h1 data-location="adminPanel" class="title">
          <span class="innerTitle" i18n="@@welcome.title">Welcome, </span>
          <span i18n="@@welcome.administrator">administrator</span>
        </h1>
        <p
          data-location="adminPanel"
          class="adminText"
          i18n="@@welcome.tap.adminpage"
        >
          tap to continue the admin landing page
        </p>
        <app-version alignment="align-center"></app-version>
      </div>
    </div>

    <div class="welcome-sect">
      <div class="col text-center">
        <p class="menuItem" i18n="@@buildinglist.table.nav.title">
          Building list
        </p>
        <button
          type="button"
          class="welcome-btn"
          data-location="buildingList"
          (click)="navigate('/building-table')"
        >
          <img
            src="assets/Keen&Wise_up.png"
            class="arrowBtn"
            data-location="buildingList"
          />
        </button>
      </div>
    </div>
  </div>
</div>
